export default "__VITE_ASSET__CWSmzAfJ__"